import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { TaskMangementModule as store } from '@blade-sxp/task-management/store/index';
import { EVENT_KEY } from '@blade-sxp/task-management/interfaces/index';
let EntranceExit = class EntranceExit extends Vue {
    devices;
    info;
    limitCount;
    dataType;
    disabled;
    maxlength = 20; // 限制输入20个文字
    get computedCount() {
        const total = this.limitCount;
        const addCount = this.info?.list?.length ?? 0;
        return `${addCount}/${total}`;
    }
    get isDisabledAdd() {
        const total = this.limitCount;
        const nowCount = this.info?.list?.length ?? 0;
        return !(nowCount < total);
    }
    onChangeDevices(nv) {
        this.updateSelectDevices();
    }
    // 更新选中的设备
    updateSelectDevices() {
        const allDeviceIds = this.devices;
        this.info.list?.map((item) => {
            const ids = item.list;
            item.list = ids.filter((id) => allDeviceIds.find((d) => d.id === id));
            if (item.list.length === 0)
                this.selectChange([]);
            return item;
        });
    }
    // // 更新选中设备显示，如有删除的设备需要删除选中的
    // deleteSelectedDeice({ id = '' }: EventParam) {
    //   if (!id) return;
    //   this.info.list?.find((item) => !(item.name && item.list.length === 0));
    // }
    addItem() {
        const list = this.info?.list ?? [];
        const timeStap = new Date().getTime();
        const emptyItem = {
            id: `${this.dataType}_${timeStap}`,
            name: '',
            dataType: this.dataType,
            list: [],
            position: null,
        };
        this.$emit('update:info', {
            ...this.info,
            list: list.push(emptyItem),
        });
    }
    removeItem(iconInfo, index) {
        this.removeMark(iconInfo);
        const list = this.info?.list ?? [];
        const targetList = list.splice(index, 1);
        this.$emit('update:info', {
            ...this.info,
            list: targetList,
        });
    }
    selectChange(strs) {
        this.$emit('selectChange', strs);
        // 设备删除为0后，需要清空地图的图标标记
        if (strs.length === 0) {
            const iconInfo = this.info.list?.find((item) => !(item.name && item.list.length === 0));
            this.removeMark(iconInfo);
        }
    }
    changeInput(str) {
        const name = str.trim();
        // 名称为空，清除地图对应的图标标记
        if (!name) {
            const iconInfo = this.info.list?.find((item) => !(item.name && item.list.length === 0));
            this.removeMark(iconInfo);
        }
    }
    removeMark(iconInfo) {
        if (!iconInfo)
            return;
        store.updateEventData({
            eventKey: EVENT_KEY['removeMark'],
            type: 'icon',
            param: iconInfo,
        });
    }
};
__decorate([
    Prop()
], EntranceExit.prototype, "devices", void 0);
__decorate([
    Prop()
], EntranceExit.prototype, "info", void 0);
__decorate([
    Prop({ type: Number, default: 10 })
], EntranceExit.prototype, "limitCount", void 0);
__decorate([
    Prop()
], EntranceExit.prototype, "dataType", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], EntranceExit.prototype, "disabled", void 0);
__decorate([
    Watch('devices')
], EntranceExit.prototype, "onChangeDevices", null);
EntranceExit = __decorate([
    Component({
        name: 'entranceExitItem',
        components: {},
        i18n: {
            messages: {
                en: {
                    add: 'Add',
                },
                zh: {
                    add: '添加',
                },
            },
        },
    })
], EntranceExit);
export default EntranceExit;
